import React from 'react';
import { withMediaProps } from 'react-media-player';
import { Button } from 'reactstrap';

const PlayPause = React.memo( ( { media, disabled } ) => (
  <Button
    type="button"
    onClick={media.playPause}
    disabled={disabled}
  >
    {media.isPlaying ? <i className="fa fa-pause" /> : <i className="fa fa-play" />}
  </Button>
) );

export default withMediaProps( PlayPause );
